import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import useQuery from '../../hooks/useQuery';
import Login from '../login';
import NotFound from '../not-found';
import { AccountManager, Util, Head } from '@bluedolphin/util-module-mf';

/**
 * Signup page component
 *
 * @returns {JSX.Element}
 */
export default function Signup() {
    const { invite_id: inviteId } = useQuery();
    const { tenantId } = useParams<any>();
    const { t } = useTranslation();

    /**
     * Updates Document title
     *
     * If a user signs up then msal session in cleared,
     * forces the logout and refreshes other pages to go to login page.
     */
    useEffect(() => {
        Head.setTitle(t('tabTitle'));
        if (tenantId && inviteId) {
            const account = { inviteId };
            AccountManager.clearMsalSession();
            AccountManager.setTenant(tenantId, account);
            AccountManager.setItem('logout', true);
            AccountManager.setTenantName(tenantId);
            Util.setGoTo(tenantId);
        }
    }, []);

    if (!tenantId || !inviteId) {
        return <NotFound />;
    }

    return <Login />;
}
